import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { Field } from 'react-final-form';
import { compose, filter, not, propEq } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { getResponsibleUsers } from 'actions/asyncActions';
import Select from 'components/common/form/Select';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import CustomIcon from 'components/common/CustomIcon';

const getManagerList = (users, current) => filter(compose(not, propEq('id', current.id)), users);

@withAutoFocusForm
@withAsyncActions({
    getResponsibleUsers: getResponsibleUsers
        .withSuccessHandler(({ user, getResponsibleUsers: { data }, form: { change } }) => {
            const options = getManagerList(data, user);

            if (options.length === 1) {
                change('responsible', options[0].id);
            }
        })
}, { dispatchOnMount: true })
export default class ManagerForm extends Component {
    render () {
        const { getResponsibleUsers: { data: responsible }, user } = this.props;

        return (
            <div className='card'>
                <div className='card-head'>
                    <h3>
                        <CustomIcon type="user-man" />
                        <Translate content='request.headers.hr_manager' />
                    </h3>
                </div>
                <div className="card-body">
                    <Field name='responsible'
                           component={Select}
                           options={getManagerList(responsible, user)}
                           namePath='name'
                           showSearch
                           label={{ content: 'request.responsible', required: true }}
                           placeholder={<Translate content='placeholders.chooseManager' />}
                    />
                </div>
            </div>
        );
    }
}
